import { useState, useRef, useEffect, useCallback } from 'react';
import { Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import Checkbox from 'src/components/Checkbox';
import Button from 'src/components/Button';
import { useClickAway } from 'src/hooks/useClickAway';
import { useStyles } from './AppBar.styles';

export const All_Languages = [
  { name: 'Afrikaans', id: 'af' },
  { name: 'Albanian', id: 'sq' },
  {
    name: 'Arabic',
    id: 'ar-all',
    children: [
      { name: 'Arabic', id: 'ar' },
      { name: 'Arabic (Algeria)', id: 'ar-dz' },
      { name: 'Arabic (Bahrain)', id: 'ar-bh' },
      { name: 'Arabic (Egypt)', id: 'ar-eg' },
      { name: 'Arabic (Iraq)', id: 'ar-iq' },
      { name: 'Arabic (Jordan)', id: 'ar-jo' },
      { name: 'Arabic (Kuwait)', id: 'ar-kw' },
      { name: 'Arabic (Lebanon)', id: 'ar-lb' },
      { name: 'Arabic (Libya)', id: 'ar-ly' },
      { name: 'Arabic (Morocco)', id: 'ar-ma' },
      { name: 'Arabic (Oman)', id: 'ar-om' },
      { name: 'Arabic (Qatar)', id: 'ar-qa' },
      { name: 'Arabic (Saudi Arabia)', id: 'ar-sa' },
      { name: 'Arabic (Syria)', id: 'ar-sy' },
      { name: 'Arabic (Tunisia)', id: 'ar-tn' },
      { name: 'Arabic (U.A.E.)', id: 'ar-ae' },
      { name: 'Arabic (Yemen)', id: 'ar-ye' },
    ],
  },
  { name: 'Basque', id: 'eu' },
  { name: 'Belarusian', id: 'be' },
  { name: 'Bulgarian', id: 'bg' },
  { name: 'Catalan', id: 'ca' },
  {
    name: 'Chinese',
    id: 'zh-all',
    children: [
      { name: 'Chinese', id: 'zh' },
      { name: 'Chinese (Hong Kong)', id: 'zh-hk' },
      { name: 'Chinese (PRC)', id: 'zh-cn' },
      { name: 'Chinese (Singapore)', id: 'zh-sg' },
      { name: 'Chinese (Taiwan)', id: 'zh-tw' },
    ],
  },
  { name: 'Croatian', id: 'hr' },
  { name: 'Czech', id: 'cs' },
  { name: 'Danish', id: 'da' },
  {
    name: 'Dutch',
    id: 'nl-all',
    children: [
      { name: 'Dutch (Standard)', id: 'nl' },
      { name: 'Dutch (Belgium)', id: 'nl-be' },
    ],
  },
  {
    name: 'English',
    id: 'en-all',
    children: [
      { name: 'English', id: 'en' },
      { name: 'English (Australia)', id: 'en-au' },
      { name: 'English (Belize)', id: 'en-bz' },
      { name: 'English (Canada)', id: 'en-ca' },
      { name: 'English (Ireland)', id: 'en-ie' },
      { name: 'English (Jamaica)', id: 'en-jm' },
      { name: 'English (New Zealand)', id: 'en-nz' },
      { name: 'English (South Africa)', id: 'en-za' },
      { name: 'English (Trinidad)', id: 'en-tt' },
      { name: 'English (United Kingdom)', id: 'en-gb' },
      { name: 'English (United States)', id: 'en-us' },
    ],
  },
  { name: 'Estonian', id: 'et' },
  { name: 'Faeroese', id: 'fo' },
  { name: 'Farsi', id: 'fa' },
  { name: 'Finnish', id: 'fi' },
  {
    name: 'French',
    id: 'fr-all',
    children: [
      { name: 'French (Standard)', id: 'fr' },
      { name: 'French (Belgium)', id: 'fr-be' },
      { name: 'French (Canada)', id: 'fr-ca' },
      { name: 'French (Luxembourg)', id: 'fr-lu' },
      { name: 'French (Switzerland)', id: 'fr-ch' },
    ],
  },
  { name: 'Gaelic (Scotland)', id: 'gd' },
  {
    name: 'German',
    id: 'de-all',
    children: [
      { name: 'German (Standard)', id: 'de' },
      { name: 'German (Austria)', id: 'de-at' },
      { name: 'German (Liechtenstein)', id: 'de-li' },
      { name: 'German (Luxembourg)', id: 'de-lu' },
      { name: 'German (Switzerland)', id: 'de-ch' },
    ],
  },
  { name: 'Greek', id: 'el' },
  { name: 'Hebrew', id: 'he' },
  { name: 'Hindi', id: 'hi' },
  { name: 'Hungarian', id: 'hu' },
  { name: 'Icelandic', id: 'is' },
  { name: 'Indonesian', id: 'id' },
  { name: 'Irish', id: 'ga' },
  {
    name: 'Italian',
    id: 'it-all',
    children: [
      { name: 'Italian (Standard)', id: 'it' },
      { name: 'Italian (Switzerland)', id: 'it-ch' },
    ],
  },
  { name: 'Japanese', id: 'ja' },
  { name: 'Korean', id: 'ko' },
  { name: 'Kurdish', id: 'ku' },
  { name: 'Latvian', id: 'lv' },
  { name: 'Lithuanian', id: 'lt' },
  { name: 'Macedonian (FYROM)', id: 'mk' },
  { name: 'Malayalam', id: 'ml' },
  { name: 'Malaysian', id: 'ms' },
  { name: 'Maltese', id: 'mt' },
  { name: 'Norwegian', id: 'no' },
  { name: 'Norwegian (Bokmål)', id: 'nb' },
  { name: 'Norwegian (Nynorsk)', id: 'nn' },
  { name: 'Polish', id: 'pl' },
  {
    name: 'Portuguese',
    id: 'pt-all',
    children: [
      { name: 'Portuguese (Brazil)', id: 'pt-br' },
      { name: 'Portuguese (Portugal)', id: 'pt' },
    ],
  },
  { name: 'Punjabi', id: 'pa' },
  { name: 'Rhaeto-Romanic', id: 'rm' },
  {
    name: 'Romanian',
    id: 'ro-all',
    children: [
      { name: 'Romanian', id: 'ro' },
      { name: 'Romanian (Republic of Moldova)', id: 'ro-md' },
    ],
  },
  {
    name: 'Russian',
    id: 'ru-all',
    children: [
      { name: 'Russian', id: 'ru' },
      { name: 'Russian (Republic of Moldova)', id: 'ru-md' },
    ],
  },
  { name: 'Serbian', id: 'sr' },
  { name: 'Slovak', id: 'sk' },
  { name: 'Slovenian', id: 'sl' },
  { name: 'Sorbian', id: 'sb' },
  {
    name: 'Spanish',
    id: 'es-all',
    children: [
      { name: 'Spanish (Argentina)', id: 'es-ar' },
      { name: 'Spanish (Bolivia)', id: 'es-bo' },
      { name: 'Spanish (Chile)', id: 'es-cl' },
      { name: 'Spanish (Colombia)', id: 'es-co' },
      { name: 'Spanish (Costa Rica)', id: 'es-cr' },
      { name: 'Spanish (Dominican Republic)', id: 'es-do' },
      { name: 'Spanish (Ecuador)', id: 'es-ec' },
      { name: 'Spanish (El Salvador)', id: 'es-sv' },
      { name: 'Spanish (Guatemala)', id: 'es-gt' },
      { name: 'Spanish (Honduras)', id: 'es-hn' },
      { name: 'Spanish (Mexico)', id: 'es-mx' },
      { name: 'Spanish (Nicaragua)', id: 'es-ni' },
      { name: 'Spanish (Panama)', id: 'es-pa' },
      { name: 'Spanish (Paraguay)', id: 'es-py' },
      { name: 'Spanish (Peru)', id: 'es-pe' },
      { name: 'Spanish (Puerto Rico)', id: 'es-pr' },
      { name: 'Spanish (Spain)', id: 'es' },
      { name: 'Spanish (Uruguay)', id: 'es-uy' },
      { name: 'Spanish (Venezuela)', id: 'es-ve' },
    ],
  },
  {
    name: 'Swedish',
    id: 'sv-all',
    children: [
      { name: 'Swedish', id: 'sv' },
      { name: 'Swedish (Finland)', id: 'sv-fi' },
    ],
  },
  { name: 'Thai', id: 'th' },
  { name: 'Tsonga', id: 'ts' },
  { name: 'Tswana', id: 'tn' },
  { name: 'Turkish', id: 'tr' },
  { name: 'Ukrainian', id: 'ua' },
  { name: 'Urdu', id: 'ur' },
  { name: 'Venda', id: 've' },
  { name: 'Vietnamese', id: 'vi' },
  { name: 'Welsh', id: 'cy' },
  { name: 'Xhosa', id: 'xh' },
  { name: 'Yiddish', id: 'ji' },
  { name: 'Zulu', id: 'zu' },
];

interface LanguageFilterProps {
  isOpen: boolean;
  isSmallSidebar?: boolean;
  handleClose: () => void;
  selectedLanguages: string[];
  excludedLanguages: string[];
  setSelectedLanguages: (languages: string[]) => void;
  setExcludedLanguages: (languages: string[]) => void;
}

export const LanguageFilter = ({
  isOpen,
  isSmallSidebar = false,
  handleClose,
  selectedLanguages,
  excludedLanguages,
  setSelectedLanguages,
  setExcludedLanguages,
}: LanguageFilterProps) => {
  const classes = useStyles();
  const ref = useRef<any>();
  const [data, setData] = useState<any[]>([]);
  const [searchKey, setSearchKey] = useState<string>('');
  const [isExclude, setIsExclude] = useState(false);

  useClickAway({ ref, handleClickAway: handleClose });

  const formatTreeData = useCallback(
    (tree: any, isClear?: boolean): any[] => {
      const temp: any[] = [];
      tree
        .sort((a: any, b: any) => (a.name > b.name ? 1 : -1))
        .forEach((item: any) => {
          const children =
            item.children && item.children.length
              ? formatTreeData(item.children, isClear)
              : undefined;
          const isParent = item.children && !!item.children.length;
          temp.push({
            ...item,
            isChecked: isClear
              ? false
              : isParent
              ? item.children.every((language: any) =>
                  isExclude
                    ? excludedLanguages.includes(language.id)
                    : selectedLanguages.includes(language.id)
                )
              : isExclude
              ? excludedLanguages.includes(item.id)
              : selectedLanguages.includes(item.id),
            isExpanded: false,
            isShow: true,
            children,
          });
        });
      return temp;
    },
    [selectedLanguages, excludedLanguages]
  );

  const filterTreeData = useCallback(
    (tree: any, key: string, isParentShow = false): any[] => {
      const temp: any[] = [];
      tree.forEach((item: any) => {
        const isShow = item.name.toLowerCase().includes(key.toLowerCase());
        const children =
          item.children && item.children.length
            ? filterTreeData(item.children, key, isShow || isParentShow)
            : [];

        temp.push({
          ...item,
          isShow:
            key === '' ||
            isShow ||
            isParentShow ||
            (item.children &&
            item.children.length &&
            item.children.some((language: any) =>
              language.name.toLowerCase().includes(key.toLowerCase())
            )
              ? true
              : false),
          children,
        });
      });
      return temp;
    },
    []
  );

  const countShowData = useCallback((tree: any): number => {
    let counter = 0;
    tree.forEach((item: any) => {
      const childCounter =
        item.children && item.children.length
          ? countShowData(item.children)
          : 0;
      const currentCounter = childCounter ? childCounter : item.isShow ? 1 : 0;
      counter = counter + currentCounter;
    });
    return counter;
  }, []);

  useEffect(() => {
    setData(filterTreeData(data, searchKey || ''));
  }, [searchKey]);

  const saveSelection = useCallback((tree: any[]) => {
    let temp: string[] = [];
    tree.forEach((item: any) => {
      if (item.children && item.children.length) {
        const children = saveSelection(item.children);
        temp = [...temp, ...children];
      } else if (item.isChecked) {
        temp.push(item.id);
      }
    });
    return temp;
  }, []);

  useEffect(() => {
    if (isOpen) {
      setSearchKey('');
      setData(formatTreeData(All_Languages));
    }
  }, [isOpen, isExclude]);

  const updateTreeData = useCallback(
    (
      tree: any[],
      id: string,
      property: string,
      propertyValue: string | boolean
    ): any[] => {
      const temp: any[] = [...tree];
      tree.forEach((node, index) => {
        if (node.id === id) {
          temp[index][property] = propertyValue;
          if (
            property === 'isChecked' &&
            node.children &&
            node.children.length
          ) {
            const children = node.children.map((child: any) => {
              updateTreeData(node.children, child.id, property, propertyValue);
              return {
                ...child,
                isChecked: propertyValue,
              };
            });
            temp[index].children = children;
          }
        } else {
          if (node.children && node.children.length) {
            const children = updateTreeData(
              node.children,
              id,
              property,
              propertyValue
            );
            let isChecked = node.isChecked;
            if (property === 'isChecked') {
              isChecked = children.every((child) => child.isChecked);
            }
            temp[index] = {
              ...node,
              children,
              isChecked,
            };
          }
        }
      });
      return temp;
    },
    []
  );

  const showCategories = (categories: any[]) => {
    return categories.map((item: any) => {
      const hasChildren = !!item.children?.length;
      if (!item.isShow) {
        return null;
      }

      return (
        <div key={item.id}>
          <div className={classes.selectOption}>
            {hasChildren ? (
              item.isExpanded ? (
                <KeyboardArrowDownIcon
                  onClick={() => {
                    setData(updateTreeData(data, item.id, 'isExpanded', false));
                  }}
                />
              ) : (
                <KeyboardArrowRightIcon
                  onClick={() => {
                    setData(updateTreeData(data, item.id, 'isExpanded', true));
                  }}
                />
              )
            ) : (
              <div style={{ width: 16 }} />
            )}
            <Checkbox
              name={item.id}
              label=''
              checked={item.isChecked}
              noPadding={true}
              onChange={() => {
                if (item.isChecked) {
                  setData(updateTreeData(data, item.id, 'isChecked', false));
                } else {
                  setData(updateTreeData(data, item.id, 'isChecked', true));
                }
              }}
              disabled={isExclude ? false : excludedLanguages.includes(item.id)}
            />
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'normal',
                color:
                  !isExclude && excludedLanguages.includes(item.id)
                    ? 'rgba(0,0,0,0.45)'
                    : 'rgba(0,0,0,0.87)',
              }}
            >
              {item.name} {hasChildren ? <>({item.children?.length})</> : null}
            </Typography>
          </div>
          <div className={classes.selectChildren}>
            {hasChildren && item.isExpanded && showCategories(item.children)}
          </div>
        </div>
      );
    });
  };

  const searchResultCounter = countShowData(data);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={classes.selectionContainer}
      style={{ left: isSmallSidebar ? 372 : 552 }}
      ref={ref}
    >
      <div className={classes.selectionMain}>
        <div className={classes.selectionHeader}>
          <Typography
            style={{
              fontSize: 16,
              color: 'gray',
              fontWeight: 'normal',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <span>Find podcasts by their languages</span>
          </Typography>
          <div>
            <div className={classes.buttonGroup}>
              <Button
                title='Include'
                color={isExclude ? 'secondary' : 'primary'}
                variant={isExclude ? 'outlined' : 'contained'}
                fontSize='sm'
                height={30}
                onClick={() => {
                  setIsExclude(false);
                }}
              />
              <Button
                title='Exclude'
                color={isExclude ? 'primary' : 'secondary'}
                variant={isExclude ? 'contained' : 'outlined'}
                fontSize='sm'
                height={30}
                onClick={() => {
                  setIsExclude(true);
                }}
              />
            </div>
          </div>
          <div className={classes.searchContainer}>
            <SearchIcon />
            <input
              placeholder='Search languages...'
              id={searchKey}
              onChange={(e) => setSearchKey(e.target.id)}
            />
          </div>
          <Typography
            style={{
              fontSize: 12,
              fontWeight: 'normal',
            }}
          >
            {!searchKey
              ? `Showing ${searchResultCounter} results`
              : `Showing ${searchResultCounter} results for ${searchKey}`}
          </Typography>
        </div>
        <div className={classes.selectionOptions}>{showCategories(data)}</div>
      </div>
      <div className={classes.selctionActions}>
        <Button
          title='Clear Selection'
          color='primary'
          variant='text'
          fontSize='sm'
          height={30}
          onClick={() => {
            setData(formatTreeData(All_Languages, true));
            setSearchKey('');
          }}
        />
        <Button
          title={isExclude ? 'Exclude Languages' : 'Select Languages'}
          color='primary'
          fontSize='sm'
          height={30}
          onClick={() => {
            const selectedData = saveSelection(data);
            if (isExclude) {
              setExcludedLanguages(selectedData);
              setSelectedLanguages(
                selectedLanguages.filter((item) => !selectedData.includes(item))
              );
            } else {
              setSelectedLanguages(selectedData);
            }

            handleClose();
            setSearchKey('');
            setData([]);
          }}
        />
      </div>
    </div>
  );
};
